import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipePipe } from '../pipes/filter-pipe.pipe';
import { ChartsModule } from "ng2-charts";


@NgModule({
  declarations: [
    FilterPipePipe
  ],
  imports: [
    CommonModule,
    ChartsModule,
  ],
  exports:[
    FilterPipePipe,
    ChartsModule,
  ]
})
export class SharedModule { }
